var n=function(n){var o;return n?"object"==typeof n?null!==(o=null==n?void 0:n.name)&&void 0!==o?o:"":n:""};export{n as getPackageValueForEEC};
//# sourceMappingURL=getPackageValueForEEC.js.map
